<template>
  <div>
    <Loader :loader-primario="loader" />

    <Alerta
      v-on:fecharModal="fecharModal"
      :exibir="modal.exibir"
      :titulo="modal.titulo"
      :mensagem="modal.mensagem"
    />

    <v-container>
      <v-row>
        <v-col cols="12" class="header">
          <h2 class="ms-4">Detalhes</h2>
        </v-col>
        <v-col cols="12">
          <p><b>Gestor Avaliador:</b> {{ dadosFeedback.nomeGestor }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2 class="categoria titulo-secao">Feedback</h2>
          <p><b>Cometários do gestor:</b> {{ dadosFeedback.comentarioFeedback }}</p>
        </v-col>
        <v-col cols="12">
          <h2 class="categoria titulo-secao">Anexos</h2>
          <p><b>Estes documentos foram incluídos pelo avaliador como parte do feedback:</b></p>
          <template v-for="anexo in anexos">
            <FileViewer :file="anexo" class="mb-2" />
          </template>
          <template v-if="!anexos.length">
            <p>
              <v-icon size="20" class="me-2">fas fa-triangle-exclamation</v-icon>
              <b>Aviso! Nenhum arquivo foi incluído pelo avaliador para este feedback</b>
            </p>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import Alerta from '@/components/Alerta.vue';
import FileViewer from '@/components/FileViewer.vue';
import modalMixin from '@/mixins/modalMixin';
import api from '@/services/Api.js';
import JS from '../methods.js';

export default {
  name: 'ViewFeedback',
  components: { Loader, Alerta, FileViewer, api },
  mixins: [modalMixin],
  props: {
    cod_avaliacao: { type: Number, default: null },
  },
  data() {
    return {
      loader: false,
      dadosFeedback: {},
      anexos: [],
    };
  },
  methods: {
    ...JS,
    async fetchFeedback() {
      if (!this.cod_avaliacao) return;
      this.loader = true;

      try {
        const { data } = await api.get(
          `avaliacaoDesempenho/feedbackColaborador/${this.cod_avaliacao}`
        );
        this.dadosFeedback = data;
        this.anexos = data.anexos.map(file => JS.createFileFromBase64(file.nomeAnexo, file.anexo));
      } catch (e) {
        this.mensagemErro(e.message);
      } finally {
        this.loader = false;
      }
    },
  },
  async mounted() {
    this.fetchFeedback();
  },
};
</script>

<style scoped>
.categoria {
  position: relative;
  padding-left: 1rem;
}
.categoria::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0.25rem;
  height: 90%;
  background-color: #278b97;
  border-radius: 0.25rem 0 0 0.25rem;
}
</style>
